import OneSignalError from "./OneSignalError";
export default class TimeoutError extends OneSignalError {
    constructor(message = "The asynchronous operation has timed out.") {
        super(message);
        this.message = message;
    }
}
//# sourceMappingURL=TimeoutError.js.map